module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "单品名称",
      "required": ""
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "请输入单品名称(必填)"
    },
    model: {
      value: (_vm.Form.ProName),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProName", $$v)
      },
      expression: "Form.ProName"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(" " + _vm._s(_vm.Form.ProName))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "单品简称",
      "required": ""
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "请输入单品简称(必填)"
    },
    model: {
      value: (_vm.Form.ProNick),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProNick", $$v)
      },
      expression: "Form.ProNick"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(" " + _vm._s(_vm.Form.ProNick))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "单品编号",
      "required": ""
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "请输入单品编号(必填)"
    },
    model: {
      value: (_vm.Form.ProCode),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProCode", $$v)
      },
      expression: "Form.ProCode"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProCode))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "required": ""
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    model: {
      value: (_vm.Form.ProClass),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProClass", $$v)
      },
      expression: "Form.ProClass"
    }
  }, _vm._l((_vm.Class), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Key))])
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProClassName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "属性",
      "required": ""
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    model: {
      value: (_vm.Form.ProAttribute),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProAttribute", $$v)
      },
      expression: "Form.ProAttribute"
    }
  }, _vm._l((_vm.Attribute), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Key))])
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProAttributeName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "种类",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.ProCategory),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProCategory", $$v)
      },
      expression: "Form.ProCategory"
    }
  }, _vm._l((_vm.Category), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(1)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProCategoryName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型/科目",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.ProTypeId),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProTypeId", $$v)
      },
      expression: "Form.ProTypeId"
    }
  }, _vm._l((_vm.ProTypeName), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(2)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProTypeName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货仓库类型",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.StockType),
      callback: function($$v) {
        _vm.$set(_vm.Form, "StockType", $$v)
      },
      expression: "Form.StockType"
    }
  }, _vm._l((_vm.StockTypeNames), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.id,
        "label": option.name
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.StockTypeName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.ProBrand),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProBrand", $$v)
      },
      expression: "Form.ProBrand"
    }
  }, _vm._l((_vm.Brand), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(3)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProBrandName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格/类别",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.ProSpec),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProSpec", $$v)
      },
      expression: "Form.ProSpec"
    }
  }, _vm._l((_vm.ProSpecName), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(4)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProSpecName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号/册数",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.ProModelNum),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProModelNum", $$v)
      },
      expression: "Form.ProModelNum"
    }
  }, _vm._l((_vm.ProModelNumName), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(5)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProModelName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自然单位",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.activenaturalUnits),
      callback: function($$v) {
        _vm.activenaturalUnits = $$v
      },
      expression: "activenaturalUnits"
    }
  }, _vm._l((_vm.naturalUnits), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(6)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProNaturalUnitName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售单位",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.activesaleUnits),
      callback: function($$v) {
        _vm.activesaleUnits = $$v
      },
      expression: "activesaleUnits"
    }
  }, _vm._l((_vm.saleUnits), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.mydialog(7)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.ProSaleUnitName))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "500px",
      "margin-left": "-2px"
    },
    attrs: {
      "label": "比例",
      "required": ""
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Form.ProProportion1),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProProportion1", $$v)
      },
      expression: "Form.ProProportion1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProNaturalUnit),
      expression: "Form.ProNaturalUnit"
    }],
    staticStyle: {
      "margin-left": "2px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }]
  }, [_vm._v("(" + _vm._s(_vm.Form.ProNaturalUnit) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("等于")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Form.ProProportion2),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProProportion2", $$v)
      },
      expression: "Form.ProProportion2"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProSaleUnit),
      expression: "Form.ProSaleUnit"
    }],
    staticStyle: {
      "margin-left": "2px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }]
  }, [_vm._v("(" + _vm._s(_vm.Form.ProSaleUnit) + ")")])])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }]
  }, [_c('el-col', {
    staticStyle: {
      "margin-left": "25px",
      "width": "60%"
    },
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.Form.ProProportion1) + "(" + _vm._s(_vm.Form.ProNaturalUnit) + ")")]), _vm._v("\n                    等于\n                    "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.Form.ProProportion2) + "(" + _vm._s(_vm.Form.ProSaleUnit) + ")")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "上传图片"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    class: {
      a: !_vm.isEdit
    },
    attrs: {
      "id": "container1"
    }
  }, [_vm._l((_vm.PictureList), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.Upload),
        expression: "Upload"
      }],
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.Upload),
        expression: "Upload"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PictureList.length == 0 && !_vm.isEdit),
      expression: "PictureList.length==0&&!isEdit"
    }]
  }, [_vm._v("--")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Upload && !_vm.fullPicture),
      expression: "Upload&&!fullPicture"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "selectfiles1"
    }
  })], 2)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "原价(必填)"
    },
    model: {
      value: (_vm.Form.Price),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Price", $$v)
      },
      expression: "Form.Price"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "span": 2
    }
  }, [_vm._v("元")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(" " + _vm._s(_vm.Form.Price))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售价",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "销售价(必填)"
    },
    model: {
      value: (_vm.Form.SalePrice),
      callback: function($$v) {
        _vm.$set(_vm.Form, "SalePrice", $$v)
      },
      expression: "Form.SalePrice"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "span": 2
    }
  }, [_vm._v("元")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(" " + _vm._s(_vm.Form.SalePrice))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注(选填)"
    },
    model: {
      value: (_vm.Form.ProRemark),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProRemark", $$v)
      },
      expression: "Form.ProRemark"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [(_vm.Form.ProRemark != undefined && _vm.Form.ProRemark != '') ? _c('span', [_vm._v(_vm._s(_vm.Form.ProRemark))]) : _c('span', [_vm._v("--")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.table.title,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.dialogClosed
    },
    model: {
      value: (_vm.visibleShow),
      callback: function($$v) {
        _vm.visibleShow = $$v
      },
      expression: "visibleShow"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ParmName",
      "label": _vm.table.label,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delTable(scope.$index, scope.row, _vm.table.type)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogContent),
      callback: function($$v) {
        _vm.dialogContent = $$v
      },
      expression: "dialogContent"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addDialog(_vm.table.type)
      }
    }
  }, [_vm._v("添 加")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.PictureVisible),
      callback: function($$v) {
        _vm.PictureVisible = $$v
      },
      expression: "PictureVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-393eee00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productInformation/addProduct.vue
// module id = 1458
// module chunks = 1